<template lang="pug">
  div.ymap-conatainer
    Button(label="Посмотреть на карте" :action="showModal")
</template>

<script>
import yMapContent from "@/components/ui/custom/map/recordMapContent.vue";
import Button from "@/components/Button";
import { mapActions, mapGetters } from "vuex";
import { errorAlert } from "@/vendor/alerts";

export default {
  components: { Button },
  computed: {
    ...mapGetters({
      formData: "form/data"
    }),
    filial() {
      return this.formData &&
        this.formData.filial &&
        this.formData.filial.office_timeslots
        ? this.formData.filial
        : false;
    }
  },
  methods: {
    ...mapActions({
      setModalContent: "modal/set"
    }),
    showModal() {
      if (!this.filial) {
        errorAlert(
          "Для просмотра карты необходимо выбрать филиал и дату посещения"
        );
      } else {
        this.setModalContent(yMapContent);
      }
    }
  }
};
</script>

<style lang="scss">
.ymap-conatainer {
  position: relative;
  height: 117px;
  background: url("/img/map-placeholder.jpg");
  background-size: cover;
  border-radius: 14px;

  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 18px 46px;
    background: transparent;
    border: 1px solid #ffffff;
    box-sizing: border-box;
  }

  button:hover {
    background: #fff;
    color: #3b7bbe;
  }
}
</style>
